// extracted by mini-css-extract-plugin
module.exports = {"two_col_widget_container":"V2rnO","two_col_widget_heading":"WPsmn","two_col_widget_cards":"OtYwl","two_col_widget":"d2dfW"};